import { apiClient } from '@/shared/api';
import {
  handleRequest,
  type RequestHandlerOptions,
} from '@/shared/api/apiWrapper';
import type {
  UpdateBankAddressRequestDto,
  UpdateBankAddressResponseDto,
} from '../model';

const updateBankAddress = async (
  templateId: string,
  args: UpdateBankAddressRequestDto,
  options?: RequestHandlerOptions
): Promise<UpdateBankAddressResponseDto> => {
  const request = () =>
    apiClient.patch(`/operations/bank/template/${templateId}`, args);

  const response = await handleRequest<UpdateBankAddressResponseDto>(
    request,
    options
  );

  return response.data;
};

const deleteBankAddress = async (
  templateId: string,
  options?: RequestHandlerOptions
): Promise<void> => {
  const request = () =>
    apiClient.delete(`/operations/bank/template/${templateId}`);
  const response = await handleRequest<void>(request, options);
  return response.data;
};

export { updateBankAddress, deleteBankAddress };
